import { render, staticRenderFns } from "./attachment-dialog.vue?vue&type=template&id=1708b54e&scoped=true&"
import script from "./attachment-dialog.vue?vue&type=script&lang=js&"
export * from "./attachment-dialog.vue?vue&type=script&lang=js&"
import style0 from "./attachment-dialog.vue?vue&type=style&index=0&id=1708b54e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708b54e",
  null
  
)

export default component.exports